import { useState } from 'react'
import './AccessDeniedBanner.css'

interface AccessDeniedBannerProps {
  onDismiss?: () => void
}

export function AccessDeniedBanner({ onDismiss }: AccessDeniedBannerProps) {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  const handleDismiss = () => {
    setDismissed(true)
    onDismiss?.()
  }

  return (
    <div className="access-denied-banner">
      <div className="access-denied-content">
        <svg className="access-denied-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" fill="currentColor"/>
        </svg>
        <div className="access-denied-text">
          <strong>Access Restricted</strong>
          <p>You no longer have access to the original data of this scenario. You're viewing a local copy that won't sync with the server.</p>
        </div>
        <button className="access-denied-dismiss" onClick={handleDismiss} aria-label="Dismiss">
          ×
        </button>
      </div>
    </div>
  )
}
